import { KeyboardEvent } from 'react';

export function preventDecimals(e: KeyboardEvent<HTMLDivElement>) {
  if (e.charCode === 46) {
    e.preventDefault();
  }
}
